module.exports = __webpack_public_path__ + "static/ariana-grande-704ebef5a1e58e8f2695e88ee683191e.jpg";